import DashboardModal from "./DashboardModal";

export default DashboardModal;
